import React, { useState } from "react"
import BackgroundSlider from "gatsby-image-background-slider"
import { useStaticQuery, graphql, Image } from "gatsby"
import { Modal } from "react-bootstrap"
import { Link } from "gatsby"

const buttonStyle = {
  backgroundColor: "#EDC02B",
  borderColor: "#EDC02B",
  borderRadius: "50px",
  fontFamily: "allotrope, sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  paddingTop: ".5rem",
  paddingLeft: "2rem",
  paddingRight: "2rem",
}

function LicensePlateModal(props) {

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <h3>USS IDAHO Commemorative License Plate</h3>
      </Modal.Header>
      <Modal.Body>
        <img
          src="/license-plate.jpg"
          alt="USS IDAHO Commemorative License Plate"
          width="100%"
          height="auto"
        />
        <p style={{textAlign: 'center', fontSize: '1.5rem', fontWeight: 500}}>
        <a href="https://dmvonline.itd.idaho.gov/OpenServices/OpenVehicleServices/CheckPersonalizedPlates" target="_blank" rel="noopener noreferrer">Available NOW at your Idaho DMV</a>
        </p>
      </Modal.Body>
    </Modal>
  )
}

const BackgroundSliderComponent = () => {
  const [showLicensePlateModal, setShowLicensePlateModal] = useState(false)

  return (
    <div style={{ width: "100%" }}>
      {/* <div
        style={{
          color: "white",
          textAlign: "center",
          backgroundColor: "#3E597F",
          width: "100%",
          padding: ".5rem",
        }}
      >
        <div>
          <h1 style={{ color: "white", marginBottom: "0" }}>
            The USS IDAHO Photo Contest - Idaho, Undersea and Underway.
          </h1>

          <div>
            <Link
              to="/photo-contest"
              style={{ color: "#EDC02B", fontWeight: 500, fontSize: "1.5rem" }}
            >
              Enter Now
            </Link>
          </div>
        </div>
      </div> */}
      <div
        style={{
          color: "white",
          textAlign: "center",
          backgroundColor: "#638FCB",
          width: "100%",
          padding: ".5rem",
        }}
      >
        <div>
          <h1 style={{ color: "white", marginBottom: "0" }}>
            USS IDAHO Commemorative License Plate
          </h1>

          <div style={{ fontWeight: 500, fontSize: "1.5rem" }}>
            <span
              style={{
                color: "#EDC02B",
                fontWeight: 500,
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
              onClick={() => setShowLicensePlateModal(true)}
            >
              Click here{" "}
            </span>
            to see the new Idaho License Plate now available at your DMV
          </div>
        </div>
      </div>
      <LicensePlateModal 
        show={showLicensePlateModal}
        onHide={() => setShowLicensePlateModal(false)}
      />
      <BackgroundSlider
        query={useStaticQuery(graphql`
          query {
            backgrounds: allFile(
              filter: { sourceInstanceName: { eq: "images" } }
            ) {
              nodes {
                relativePath
                childImageSharp {
                  fluid(maxWidth: 4000, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        `)}
        initDelay={12}
        transition={4}
        duration={10}
        images={["sub-1.jpg", "sub-2.jpg", "sub-3.jpg"]}
        style={{
          overflow: "hidden",
        }}
      />
    </div>
  )
}

export default BackgroundSliderComponent
